import { FaPlus } from 'react-icons/fa';
import { Menu, MenuItem, Typography } from '@mui/material';

import { CalendarIcon, CalenderGrayIcon, WebinarCalendarIcon } from '@src/assets/icons';

import './createMeetingMenu.scss';

interface ICreateMeetingMenu {
  anchorEl?: Element | null;
  isMenuOpen: boolean;
  isTitleEmpty: boolean;
  handleClose: () => void;
  handleOpenModal: () => void;
  joinRoom?: () => void;
  navigateToWebinar: (routeType: string) => void;
  handleScheduleInCalendar: () => void;
}

const CreateMeetingMenu = ({
  anchorEl,
  isMenuOpen,
  isTitleEmpty,
  handleClose,
  handleOpenModal,
  joinRoom,
  navigateToWebinar,
  handleScheduleInCalendar,
}: ICreateMeetingMenu) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={isMenuOpen}
      onClose={handleClose}
      PaperProps={{
        className: 'create-menu-container',
      }}
    >
      <MenuItem
        id="start-instant-meeting"
        onClick={() => {
          !isTitleEmpty && joinRoom?.();
          handleClose();
        }}
        className="create-menu-item"
      >
        <CalendarIcon />
        <Typography variant="body1">Start an instant meeting</Typography>
      </MenuItem>
      <MenuItem id="create-meeting-later" onClick={handleOpenModal} className="create-menu-item">
        <FaPlus color="#08D" />
        <Typography variant="body1">Create a meeting for later</Typography>
      </MenuItem>
      <MenuItem id="create-webinar-meeting" onClick={() => navigateToWebinar('create')} className="create-menu-item">
        <WebinarCalendarIcon />
        <Typography variant="body1">Webinar meeting</Typography>
      </MenuItem>
      <MenuItem id="schedule-in-calendar" className="create-menu-item" onClick={handleScheduleInCalendar}>
        <CalenderGrayIcon color="#08D" />
        <Typography variant="body1">Schedule in O-Mailo Calendar</Typography>
      </MenuItem>
    </Menu>
  );
};
export default CreateMeetingMenu;
